import {
  ISettingResponse,
  SearchSettingPayload,
  SearchSettingResponse,
  SettingCreateRequestPayload,
  SettingUpdateRequestPayload,
} from "../domain/setting.interface";
import { axios, transformAxiosError } from "../utils/axios.create";

const findAll = async (): Promise<ISettingResponse> => {
  return axios
    .get("/settings?application=backoffice")
    .then((res) => {
      return res.data.body;
    })
    .catch((err) => {
      return Promise.reject(err.response.data);
    });
};

const findByName = async (settingName: string): Promise<ISettingResponse> => {
  return axios
    .get(`/settings?application=backoffice&settingsName=${settingName}`)
    .then((res) => {
      const settingName = res.data.body;

      if (!settingName) {
        return Promise.reject("Setting not found");
      }

      return settingName;
    })
    .catch((err) => {
      return Promise.reject(err.response.data);
    });
};

const create = async (data: SettingCreateRequestPayload) => {
  return axios
    .post("/settings", data)
    .then((res) => res.data.body)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const update = async ({
  id,
  data,
}: {
  id: string;
  data: SettingUpdateRequestPayload;
}) => {
  return axios
    .put(`/settings/${id}`, data)
    .then((res) => res.data.body)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const softDelete = async (id: string) => {
  return axios
    .delete(`/settings/${id}`)
    .then((res) => res.data.body)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const search = async ({
  search,
  sortField,
  sortOrder,
  pageNumber,
  pageSize,
}: SearchSettingPayload): Promise<SearchSettingResponse> => {
  const queryParams = new URLSearchParams({
    pageNumber: String(pageNumber + 1),
    pageSize: String(pageSize),
    search,
    sortField,
    sortOrder: sortOrder === 1 ? "asc" : "desc",
  });

  return axios
    .get(`/settings/search?${queryParams.toString()}`)
    .then((res) => {
      const body = res.data.body;
      return {
        settings: body.settings,
        totalCount: body.totalCount,
      };
    })
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

export const settingService = {
  findAll,
  findByName,
  create,
  update,
  softDelete,
  search,
};
